import { useState } from "react";
import {
  ResponseGetAllBasesResponse,
  BasesApi,
  ResponseGetAllStatusResponse,
  StatusApi,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiGetStatusList = () => {
  const [statusList, setStautsList] = useState<
    ResponseGetAllStatusResponse[] | null
  >([]);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchStatusList = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const config = createConfiguration();

      const api = new StatusApi(config);
      const response = await api.statusGetAllGet();
      setStautsList(response);
      return response;
    } catch (err) {
      setError("拠点検索バーの取得に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { statusList, fetchStatusList, error, isLoading };
};
